import { Navigation } from "./Navigation";
import { Footer } from "./Footer";
import { CookieConsent } from "./CookieConsent";
import { Toaster } from "./ui/sonner";

export const Layout = ({ children }) => {
  return (
    <>
      <Navigation />
      <main className="min-h-screen" data-testid="main-content">
        {children}
      </main>
      <Footer />
      <CookieConsent />
      <Toaster position="top-right" richColors />
    </>
  );
};
